import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../styles/datepicker.css";
import { formatDateForApi, parseDateValue } from "../../utils/formatDate";

const toLocalDate = (value) => {
  const parsed = parseDateValue(value);
  if (!parsed) return null;
  return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
};

const DateSelector = ({
  value,
  onChange,
  error = "",
  label = "Appointment Date",
  hint = "Choose the date you would like for your appointment.",
  required = true,
  availableDates = [],
  minDate,
}) => {
  const selectedDate = value ? toLocalDate(value) : null;
  const resolvedMinDate = minDate ? toLocalDate(minDate) : new Date();

  const availableDateStrings = new Set(
    (availableDates || [])
      .map((date) => formatDateForApi(date))
      .filter(Boolean)
  );

  const isAvailableDate = (date) => {
    return availableDateStrings.has(formatDateForApi(date));
  };

  const handleChange = (date) => {
    if (!date) {
      onChange({
        target: {
          name: "bookingDate",
          value: "",
        },
      });
      return;
    }

    onChange({
      target: {
        name: "bookingDate",
        value: formatDateForApi(date),
      },
    });
  };

  return (
    <div className="w-full">
      <label className="field-label">
        {label}
        {required && <span className="ml-1 text-red-500">*</span>}
      </label>

      <DatePicker
        selected={selectedDate}
        onChange={handleChange}
        minDate={resolvedMinDate}
        inline
        calendarClassName="nayra-datepicker"
        filterDate={isAvailableDate}
        dayClassName={(date) => {
          if (isAvailableDate(date)) {
            return "nayra-available-day";
          }
          return "nayra-disabled-day";
        }}
      />

      {error ? (
        <p className="field-error">{error}</p>
      ) : (
        <p className="field-hint">{hint}</p>
      )}
    </div>
  );
};

export default DateSelector;